import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup, Table,
  Progress,
  Collapse, Button, Fade, Jumbotron,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Input,
  InputGroup,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Form,
  Pagination,
  PaginationItem,
  PaginationLink
} from 'reactstrap';
import moment from 'moment';
import { Link } from "react-router-dom";
import { makeInput } from "common-import/custom";
import { inject, observer } from "mobx-react";

import { TimeHelper, VarHelper } from "common-import/helpers"

@inject("biddingCategoryStore", "userStore") @observer
class BiddingListNotApprove extends Component {

  state = {
    keyword: "",
    page: 1
  }

  async componentDidMount() {
    const { biddingCategoryStore } = this.props;
    await this.props.userStore.onReady();
    biddingCategoryStore.getListNotApprovedUpdate();
  }

  renderRow(data, index) {
    return (

      <tr key={"row"+index}>
        <td>
          <Link to={`/bidding/${data.id}?name=${data.name}`}>
            <div><strong>{data.name}</strong></div>
            <div><i style={{fontSize: 8}}>Project Id: {data.projectId}</i></div>
          </Link>
        </td>
        <td>
          <div className="clearfix">
            <div className="float-left">{data.type}</div>
          </div>
        </td>
        <td>
          <a >
            <div>{data.city}</div>
            <div className="small text-muted">
              <span>Seal</span>: <b>{String(data.allowAlternativeBids)}</b>
            </div>
            <div className="small text-muted">
              <span>Alternative</span>: <b>{String(data.allowAlternativeBids)}</b>
            </div>
            {/* <div className="small text-muted">
              <span>Fax</span>: {data.fax}
            </div> */}
          </a>
        </td>
        <td>
          <div className="small text-muted">{data.status}</div>
        </td>
        <td>
          <div className="small text-muted"><strong>Start:</strong> {TimeHelper.toDateString(data.minStartTime)}</div>
          <div className="small text-muted"><strong>End:</strong> {TimeHelper.toDateString(data.maxFinishTime)}</div>
        </td>
      </tr>

    )
  }

  render() {
    const { biddingCategoryStore } = this.props;
    const listNotApproved = biddingCategoryStore.listNotApproved.slice();
    return (
      <div className="animated fadeIn">
        {/* <Form onSubmit={this.search}>
          <FormGroup row>
            <Col md="12">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <Button type="button" color="primary" onClick={this.search}><i className="fa fa-search"></i> Search</Button>
                </InputGroupAddon>
                {makeInput(this, "keyword")(<Input type="text" id="input1-group2" name="input1-group2" placeholder="Nhập tên để tìm dự án đã duyệt" />)}
              </InputGroup>
            </Col>
          </FormGroup>
        </Form> */}
        <Row>
          <Col xs="12" sm="12">
            <Table hover responsive className="table-outline mb-0 d-sm-table">
              <thead className="thead-light">
                <tr>
                  <th>Scope Name</th>
                  <th>Type</th>
                  <th>Seal & Alternative</th>
                  <th>Status</th>
                  <th>Duration</th>
                </tr>
              </thead>
              <tbody style={{backgroundColor: 'white'}}>
                {listNotApproved.length > 0 && listNotApproved.map((val, index) => this.renderRow({
                  id: val.id,
                  name: val.name,
                  type: val.typeOfBid,
                  allowAlternativeBids: val.allowAlternativeBids,
                  allowSealedBids: val.allowSealedBids,
                  status: val.status,
                  minStartTime: val.bidOpenTime,
                  maxFinishTime: val.bidCloseTime,
                  projectId: val.projectId
                }, index))}
              </tbody>
            </Table>
            {listNotApproved.length === 0 && <p style={{ marginTop: 20, testAlign: "center", display: "block" }}>Hiện chưa có hạng mục đấu thầu nào chưa được xác thực</p>}
          </Col>
        </Row>
        <Row style={{marginTop: 20, marginBottom: 20}}>
          <Col xs="12" md="12">
            <Pagination>
              <PaginationItem>
                <PaginationLink previous onClick={this.loadPrev}/>
              </PaginationItem>
              <PaginationItem>
              <PaginationLink>{this.state.page}</PaginationLink>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink next onClick={this.loadNext} />
              </PaginationItem>
            </Pagination>
          </Col>
        </Row>          
      </div>
    );
  }

  search = e => {
    !!e && e.preventDefault();
    const { biddingCategoryStore } = this.props;
    const { keyword } = this.state;
    if(keyword == "") {
      biddingCategoryStore.getListNotApproved();
    } else {
      biddingCategoryStore.search(keyword, true);
    }
  }

  loadPrev = e => {
    !!e && e.preventDefault();
    if(this.state.page === 1) return;
    const { biddingCategoryStore } = this.props;
    this.setState({ page: this.state.page - 1}, () => {
      biddingCategoryStore.getListNotApprovedUpdate(this.state.page);
    });
  }

  loadNext = e => {
    !!e && e.preventDefault();
    const { biddingCategoryStore } = this.props;
    this.setState({ page: this.state.page + 1}, () => {
      biddingCategoryStore.getListNotApprovedUpdate(this.state.page);
    });
  }
}

export default BiddingListNotApprove;


// WEBPACK FOOTER //
// ./src/views/Bidding/NotApprovedListUpdate.js